import request from '@/utils/request'

export function fetchList(cid, params) {
  return request({
    url:'/attribute/list/' + cid,
    method:'get',
    params:params
  })
}

export function deleteAttribute(data) {
  return request({
    url:'/attribute/delete',
    method:'post',
    data:data
  })
}

export function createAttribute(data) {
  return request({
    url:'/attribute/create',
    method:'post',
    data:data
  })
}

export function updateAttribute(id, data) {
  return request({
    url:'/attribute/update/' + id,
    method:'post',
    data:data
  })
}
export function getAttribute(id) {
  return request({
    url:'/attribute/' + id,
    method:'get'
  })
}

export function getAttributeInfo(categoryId) {
  return request({
    url: '/attribute/attrInfo/' + categoryId,
    method:'get'
  })
}
